import { createContext } from 'react';

import type { XYChartThresholdsInternal } from '../types/xy-chart-internals.js';

export const NoThresholdData: XYChartThresholdsInternal = {
  none: true,
  thresholds: [],
  offset: {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  },
  yAxes: {
    left: new Set(),
    right: new Set(),
  },
  xAxes: {
    top: new Set(),
    bottom: new Set(),
  },
};

export const XYChartThresholdsContext =
  createContext<XYChartThresholdsInternal>(NoThresholdData);
